/**
 * KAN-905: переключатель "Только новые лиды" рядом с периодом (доска и таблица CRM).
 * Состояние в useNewLeadsOnly; при "Всё время" неактивен.
 */
import type { NewLeadsOnlyState } from '@/hooks/useNewLeadsOnly';
import { cn } from '@/lib/utils';

export const NEW_LEADS_HINT =
  'Включено: только лиды, впервые написавшие в выбранный период. Выключено: все, у кого было движение';

export function NewLeadsToggle({ state }: { state: NewLeadsOnlyState }): JSX.Element {
  const on = state.newLeadsOnly && state.available;
  return (
    <button
      type="button"
      data-testid="crm-new-leads"
      aria-pressed={state.newLeadsOnly}
      disabled={!state.available}
      title={NEW_LEADS_HINT}
      onClick={state.toggle}
      className={cn(
        'inline-flex shrink-0 items-center whitespace-nowrap rounded-md border px-2.5 py-1 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50',
        on ? 'border-blue-600 bg-blue-600 text-white' : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'
      )}
    >
      Только новые лиды
    </button>
  );
}
